import React, { useState, useEffect, useCallback } from "react";
import { getAuth, signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { getFirestore, collection, addDoc, getDocs, query, where, doc, updateDoc, orderBy, deleteDoc, limit, onSnapshot, serverTimestamp  } from "firebase/firestore";

import { DateRange } from 'react-date-range';
import { differenceInCalendarDays } from 'date-fns';

import { format, parseISO, isToday, isAfter, isBefore, addDays, set } from 'date-fns';
import { Badge, List, Avatar, Divider, Typography, Alert } from 'antd';
import { BellOutlined, ExclamationCircleOutlined } from '@ant-design/icons';

import { enUS } from 'date-fns/locale';
import { addYears } from 'date-fns'

import * as XLSX from "xlsx";

// Ant icons you already use
import {
  UserOutlined,
  PhoneOutlined,
  PlusOutlined,
  MinusCircleOutlined,
  SaveOutlined,
  CalendarOutlined,
} from '@ant-design/icons';

// react-date-range CSS (required)
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';



import { jsPDF } from "jspdf";
import { saveAs } from "file-saver";



import dayjs from "dayjs";
import './body.css';

import { Table, Button, Popconfirm, message } from "antd";
import { DownloadOutlined, DeleteOutlined } from "@ant-design/icons";


import { Eye, Download } from "lucide-react";

const db = getFirestore();

const { Title, Text } = Typography;

const Body = () => {

  const [selectedOption, setSelectedOption] = useState("bookingConfirmation"); 
  const [userDetails, setUserDetails] = useState(null); 
  const auth = getAuth(); 
  const navigate = useNavigate(); 
  const db = getFirestore(); 




  // Handle Logout
  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/"); // Redirect to login page after logout
    } catch (error) {
      console.error("Error during logout: ", error);
    }
  };
  


  // Example: Fetch user details (you might want to update this based on your logic)
  useEffect(() => {
    // Logic to fetch user details from Firestore or Firebase Auth
    const fetchUserDetails = async () => {
      const user = auth.currentUser;
      if (user) {
        // If the user is logged in, set userDetails (you can fetch more details from Firestore if needed)
        setUserDetails({
          name: user.displayName,
          email: user.email,
        });
      }
    };

    fetchUserDetails();
  }, [auth]);




//////////////////////////////////////////////////////////// create invoice //////////////////////////////////////////////////////////////////////////

  const [invoices, setInvoices] = useState([]);
  const [invoiceNumber, setInvoiceNumber] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [showRangePickerIndex, setShowRangePickerIndex] = useState(null); // which item's date picker open

  const [formData, setFormData] = useState({
    companyName: 'Retionz Cabs & Rent A Car (PVT) LTD',
    companyAddress: 'Maharagama Rd, Piliyandala 10300, Sri Lanka',
    companyPhone: '+94 701 707 707',
    companyEmail: 'info@retionzcabs.lk',
    customerName: '',
    customerAddress: '',
    customerPhone: '',
    customerEmail: '',
    invoiceDate: new Date().toISOString().split('T')[0],
    rentalItems: [
      {
        vehicleDescription: '',
        // dateRange: we store as { startDate, endDate }
        dateRange: { startDate: new Date(), endDate: new Date() },
        ratePerDay: 0,
        numberOfDays: 1,
        numberOfKms: 0,
        extraCharges: 0,
        subtotal: 0 // user-entered manually (Option 2)
      }
    ],
    totalAmount: 0,
    paymentMethod: 'card',
    cardNumber: '',
    cardType: 'visa',
    paymentDate: new Date().toISOString().split('T')[0],
    chequeNumber: '',
    chequeDate: ''
  });

  // realtime invoice number generation
  useEffect(() => {
    const q = query(collection(db, 'invoices'), orderBy('createdAt', 'desc'));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const invoicesData = [];
      snapshot.forEach((doc) => invoicesData.push({ id: doc.id, ...doc.data() }));
      setInvoices(invoicesData);

      const lastInvoice = invoicesData[0];
      const newInvoiceNumber = lastInvoice && lastInvoice.invoiceNumber
        ? `INV-${String(parseInt(lastInvoice.invoiceNumber.split('-')[1]) + 1).padStart(4, '0')}`
        : 'INV-0001';
      setInvoiceNumber(newInvoiceNumber);
    });

    return () => unsubscribe();
  }, [db]);

  // helper for formatting display as Rs.
  const formatRs = (num) => `Rs. ${Number(num || 0).toLocaleString('en-US', { maximumFractionDigits: 2 })}`;

  // generic input change handler
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // update rental item field (for manual subtotal)
  const handleRentalItemChange = (index, field, value) => {
    const updated = [...formData.rentalItems];
    // ensure numeric types for numeric fields, but keep subtotal editable by user
    if (['ratePerDay', 'numberOfKms', 'extraCharges', 'subtotal'].includes(field)) {
      value = value === '' ? 0 : Number(value);
    }
    updated[index][field] = value;

    // If dateRange changed elsewhere, numberOfDays handled separately.
    // Recompute total from subtotals
    const total = updated.reduce((s, it) => s + (Number(it.subtotal || 0)), 0);

    setFormData(prev => ({
      ...prev,
      rentalItems: updated,
      totalAmount: total
    }));
  };

  // Update date range for an item and compute numberOfDays automatically
// index = rental item index, range = { selection: { startDate, endDate, key } }
const handleDateRangeChange = (index, range) => {
  const updated = [...formData.rentalItems];
  const sel = range.selection || range; // safe extraction
  const start = sel.startDate ? new Date(sel.startDate) : new Date();
  const end = sel.endDate ? new Date(sel.endDate) : new Date(start);

  updated[index].dateRange = { startDate: start.toISOString(), endDate: end.toISOString() };

  // auto-calc numberOfDays (inclusive)
  const days = differenceInCalendarDays(end, start) + 1;
  updated[index].numberOfDays = days > 0 ? days : 1;

  // Recompute total as sum of user-entered subtotals (since you chose subtotal manual)
  const total = updated.reduce((s, it) => s + Number(it.subtotal || 0), 0);

  setFormData(prev => ({ ...prev, rentalItems: updated, totalAmount: total }));
};







  const addRentalItem = () => {
    setFormData(prev => ({
      ...prev,
      rentalItems: [
        ...prev.rentalItems,
        {
          vehicleDescription: '',
          dateRange: { startDate: new Date(), endDate: new Date() },
          ratePerDay: 0,
          numberOfDays: 1,
          numberOfKms: 0,
          extraCharges: 0,
          subtotal: 0
        }
      ]
    }));
  };

  const removeRentalItem = (index) => {
    if (formData.rentalItems.length <= 1) return;
    const updated = formData.rentalItems.filter((_, i) => i !== index);
    const total = updated.reduce((s, it) => s + (Number(it.subtotal || 0)), 0);
    setFormData(prev => ({ ...prev, rentalItems: updated, totalAmount: total }));
  };

  const saveAndDownloadInvoice = async () => {
    if (!formData.customerName || !formData.customerPhone) {
      alert('Please fill in Customer Name and Phone.');
      return;
    }
    if (Number(formData.totalAmount) <= 0) {
      alert('Total amount must be greater than 0. Enter subtotals for rental items.');
      return;
    }

    setIsSaving(true);
    try {
      // Prepare invoice payload: convert dateRange objects to ISO strings for storage
      const payload = {
        ...formData,
        invoiceNumber,
        createdAt: new Date(),
        rentalItems: formData.rentalItems.map(it => ({
          ...it,
          dateRange: {
            startDate: it.dateRange.startDate instanceof Date ? it.dateRange.startDate.toISOString() : it.dateRange.startDate,
            endDate: it.dateRange.endDate instanceof Date ? it.dateRange.endDate.toISOString() : it.dateRange.endDate
          },
          ratePerDay: Number(it.ratePerDay || 0),
          numberOfDays: Number(it.numberOfDays || 0),
          numberOfKms: Number(it.numberOfKms || 0),
          extraCharges: Number(it.extraCharges || 0),
          subtotal: Number(it.subtotal || 0)
        })),
        totalAmount: Number(formData.totalAmount || 0),
        paymentDate: formData.paymentDate ? formData.paymentDate : null
      };

      // Save to Firestore
      await addDoc(collection(db, 'invoices'), payload);

      // Generate PDF (use payload to ensure saved values are used)
      generatePDF(payload);

      // Reset form
      resetForm();
    } catch (err) {
      console.error(err);
      alert('Failed to save invoice. See console.');
    } finally {
      setIsSaving(false);
    }
  };

const generatePDF = (invoiceData = formData) => {
  const doc = new jsPDF({
    unit: "mm",
    format: "a4",
    orientation: "portrait"
  });

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  // Professional color scheme - using hex colors instead of arrays
  const primaryColor = "#002060";        // Navy Blue
  const secondaryColor = "#f0f4ff";      // Light Blue
  const accentColor = "#ffd700";         // Gold
  const successColor = "#228b22";        // Green
  const textDark = "#333333";            // Dark Gray
  const textLight = "#ffffff";           // White

  // Load logo
  const logo = new Image();
  logo.crossOrigin = "Anonymous";
  logo.src = process.env.PUBLIC_URL + "/logo192.png";

  logo.onload = () => {
    try {
      // Background with subtle pattern
      doc.setFillColor(250, 250, 255);
      doc.rect(0, 0, pageWidth, pageHeight, "F");
      
      // Watermark background
      doc.setGState(new doc.GState({ opacity: 0.03 }));
      doc.addImage(logo, "PNG", pageWidth/2 - 50, pageHeight/2 - 50, 100, 100);
      doc.setGState(new doc.GState({ opacity: 1 }));

      // Premium header with gradient effect
      doc.setFillColor(0, 32, 96); // Navy Blue as RGB
      doc.roundedRect(10, 10, pageWidth - 20, 45, 5, 5, "F");
      
      // Company logo in header
      doc.addImage(logo, "PNG", 20, 15, 30, 30);
      
      // Company information
      doc.setTextColor(255, 255, 255); // White
      doc.setFont("helvetica", "bold");
      doc.setFontSize(16);
      doc.text("INVOICE", pageWidth - 40, 25, { align: "right" });
      
      doc.setFontSize(11);
      doc.setFont("helvetica", "bold");
      doc.text("RETIONZ CABS & RENT A CAR (PVT) LTD", 60, 22);
      doc.setFontSize(9);
      doc.setFont("helvetica", "normal");
      doc.text("Maharagama Rd, Piliyandala 10300, Sri Lanka", 60, 28);
      doc.text("+94 701 707 707 | info@retionzcabs.lk | www.retionzcabs.lk", 60, 34);
      
      // Invoice details container
      doc.setFillColor(255, 255, 255); // White
      doc.roundedRect(10, 60, pageWidth - 20, 25, 3, 3, "F");
      doc.setDrawColor(220, 220, 220);
      doc.setLineWidth(0.2);
      doc.roundedRect(10, 60, pageWidth - 20, 25, 3, 3, "S");
      
      let y = 70;
      
      // Left side - From
      doc.setTextColor(0, 32, 96); // Navy Blue
      doc.setFont("helvetica", "bold");
      doc.setFontSize(9);
      doc.text("FROM:", 20, y - 3);
      doc.setTextColor(51, 51, 51); // Dark Gray
      doc.setFont("helvetica", "normal");
      doc.text(invoiceData.companyName || "Retionz Cabs & Rent A Car (PVT) LTD", 20, y + 3);
       doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      const compAddr = doc.splitTextToSize(invoiceData.companyAddress || "Maharagama Rd, Piliyandala 10300, Sri Lanka", 60);
      doc.text(compAddr, 20, y + 7);
      
      // Right side - Invoice details
      const invoiceNo = invoiceData.invoiceNumber || `INV-${Date.now().toString().slice(-6)}`;
      const invoiceDate = invoiceData.invoiceDate || new Date().toISOString().split("T")[0];
      const dueDate = invoiceData.dueDate || new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString().split("T")[0];
      
      const invoiceDetails = [
        { label: "INVOICE NO:", value: invoiceNo },
        { label: "ISSUE DATE:", value: invoiceDate },
        { label: "DUE DATE:", value: dueDate },
        { label: "STATUS:", value: "PAID" }
      ];
      
      let detailY = y - 3;
      invoiceDetails.forEach(detail => {
        doc.setFont("helvetica", "bold");
        doc.setTextColor(0, 32, 96); // Navy Blue
        doc.setFontSize(8);
        doc.text(detail.label, pageWidth - 70, detailY);
        doc.setFont("helvetica", "normal");
        doc.setTextColor(34, 139, 34); // Green for status, dark gray for others
        if (detail.label === "STATUS:") {
          doc.setTextColor(34, 139, 34); // Success green
        } else {
          doc.setTextColor(51, 51, 51); // Dark gray
        }
        doc.text(detail.value, pageWidth - 30, detailY);
        detailY += 4;
      });

      y = 95;

      // Customer Information Section
      doc.setFillColor(240, 244, 255); // Light blue
      doc.roundedRect(15, y - 8, pageWidth - 30, 10, 2, 2, "F");
      doc.setTextColor(0, 32, 96); // Navy Blue
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      doc.text("BILL TO", 20, y - 2);

      y += 8;
      
      const customerInfo = [
        { label: "NAME:", value: invoiceData.customerName || "-" },
        { label: "PHONE:", value: invoiceData.customerPhone || "-" },
        { label: "EMAIL:", value: invoiceData.customerEmail || "-" },
        { label: "ADDRESS:", value: invoiceData.customerAddress || "-" }
      ];
      
      customerInfo.forEach(info => {
        doc.setFont("helvetica", "bold");
        doc.setTextColor(0, 32, 96); // Navy Blue
        doc.setFontSize(8);
        doc.text(info.label, 20, y);
        doc.setFont("helvetica", "normal");
        doc.setTextColor(51, 51, 51); // Dark Gray
        
        if (info.label === "ADDRESS:") {
          const addrLines = doc.splitTextToSize(info.value, 80);
          doc.text(addrLines, 40, y);
          y += addrLines.length * 4;
        } else {
          doc.text(info.value, 40, y);
          y += 5;
        }
      });

      y += 10;

      // Rental Items Table
      const tableHeaders = ["VEHICLE", "PERIOD", "DAYS", "RATE/DAY", "EXR CHARGES", "SUBTOTAL"];
      const columnWidths = [45, 40, 20, 30, 30, 25];
      const tableStartX = 15;
      
      // Table header
      doc.setFillColor(0, 32, 96); // Navy Blue
      doc.roundedRect(tableStartX, y, pageWidth - 30, 8, 2, 2, "F");
      
      let headerX = tableStartX + 2;
      doc.setTextColor(255, 255, 255); // White
      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      
      tableHeaders.forEach((header, index) => {
        doc.text(header, headerX, y + 5);
        headerX += columnWidths[index];
      });

      y += 12;

      // Table rows
      doc.setFont("helvetica", "normal");
      doc.setTextColor(51, 51, 51); // Dark Gray
      
      const rentalItems = invoiceData.rentalItems || [];
      let subtotal = 0;
      
      rentalItems.forEach((item, index) => {
        if (y > pageHeight - 50) {
          doc.addPage();
          y = 20;
          
          // Add table header on new page
          doc.setFillColor(0, 32, 96); // Navy Blue
          doc.roundedRect(tableStartX, y, pageWidth - 30, 8, 2, 2, "F");
          
          let newHeaderX = tableStartX + 2;
          doc.setTextColor(255, 255, 255); // White
          doc.setFont("helvetica", "bold");
          tableHeaders.forEach((header, idx) => {
            doc.text(header, newHeaderX, y + 5);
            newHeaderX += columnWidths[idx];
          });
          y += 12;
          doc.setFont("helvetica", "normal");
          doc.setTextColor(51, 51, 51); // Dark Gray
        }
        
        // Alternate row colors
        if (index % 2 === 0) {
          doc.setFillColor(250, 250, 255);
          doc.rect(tableStartX, y - 4, pageWidth - 30, 10, "F");
        }
        
        let rowX = tableStartX + 2;
        const rowY = y;
        
        // Vehicle description
        const vehicleText = doc.splitTextToSize(item.vehicleDescription || "-", columnWidths[0] - 4);
        doc.text(vehicleText, rowX, rowY);
        rowX += columnWidths[0];
        
        // Date period
        const startDate = item.dateRange?.startDate ? 
          new Date(item.dateRange.startDate).toLocaleDateString() : "-";
        const endDate = item.dateRange?.endDate ? 
          new Date(item.dateRange.endDate).toLocaleDateString() : "-";
        doc.text(`${startDate}\n${endDate}`, rowX, rowY);
        rowX += columnWidths[1];
        
        // Days
        doc.text(item.numberOfDays?.toString() || "0", rowX, rowY, { align: "center" });
        rowX += columnWidths[2];
        
        // Rate per day
        doc.text(`Rs. ${Number(item.ratePerDay || 0).toLocaleString()}`, rowX, rowY, { align: "right" });
        rowX += columnWidths[3];
        
        // Extra charges
        doc.text(`Rs. ${Number(item.extraCharges || 0).toLocaleString()}`, rowX, rowY, { align: "right" });
        rowX += columnWidths[4];
        
        // Subtotal
        const itemSubtotal = Number(item.subtotal || 0);
        subtotal += itemSubtotal;
        doc.text(`Rs. ${itemSubtotal.toLocaleString()}`, rowX, rowY, { align: "right" });
        
        y += Math.max(vehicleText.length * 4, 10) + 2;
      });

      // Summary section
      const summaryY = Math.min(y + 20, pageHeight - 60);
      
      doc.setFillColor(245, 245, 255);
      doc.roundedRect(pageWidth - 100, summaryY, 85, 50, 3, 3, "F");
      doc.setDrawColor(200, 200, 220);
      doc.setLineWidth(0.3);
      doc.roundedRect(pageWidth - 100, summaryY, 85, 50, 3, 3, "S");
      
      let summaryLineY = summaryY + 8;
      
      const summaryItems = [
        { label: "Subtotal:", value: subtotal },
        // { label: "Discount:", value: invoiceData.discount || 0 },
        // { label: "Tax (8%):", value: subtotal * 0.08 },
        { label: "Total:", value: invoiceData.totalAmount || (subtotal * 1.08 - (invoiceData.discount || 0)) }
      ];
      
      summaryItems.forEach((item, index) => {
        const isTotal = index === summaryItems.length - 1;
        
        doc.setFont("helvetica", isTotal ? "bold" : "normal");
        doc.setFontSize(isTotal ? 10 : 8);
        doc.setTextColor(isTotal ? 0 : 51, isTotal ? 32 : 51, isTotal ? 96 : 51); // Navy for total, dark gray for others
        
        doc.text(item.label, pageWidth - 90, summaryLineY);
        doc.text(
          `Rs. ${Number(item.value).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
          pageWidth - 25,
          summaryLineY,
          { align: "right" }
        );
        
        if (isTotal) {
          doc.setDrawColor(255, 215, 0); // Gold
          doc.setLineWidth(0.5);
          doc.line(pageWidth - 90, summaryLineY + 1, pageWidth - 25, summaryLineY + 1);
        }
        
        summaryLineY += isTotal ? 8 : 6;
      });

      // Payment method
      y = summaryY + 55;
      doc.setFont("helvetica", "bold");
      doc.setFontSize(9);
      doc.setTextColor(0, 32, 96); // Navy Blue
      doc.text("PAYMENT METHOD:", 20, y);
      doc.setFont("helvetica", "normal");
      doc.setTextColor(51, 51, 51); // Dark Gray
      doc.text((invoiceData.paymentMethod || "Cash").toString().toUpperCase(), 55, y);
      
      if (invoiceData.paymentReference) {
        doc.setFont("helvetica", "bold");
        doc.text("REFERENCE:", 20, y + 5);
        doc.setFont("helvetica", "normal");
        doc.text(invoiceData.paymentReference, 55, y + 5);
      }

      // Terms and conditions
      y += 15;
      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.setTextColor(0, 32, 96); // Navy Blue
      doc.text("TERMS & CONDITIONS:", 20, y);
      
      doc.setFont("helvetica", "normal");
      doc.setFontSize(7);
      doc.setTextColor(51, 51, 51); // Dark Gray
      const terms = [
        "• Late payments are subject to a 1.5% monthly interest fee",
        "• All rental terms and conditions apply as per agreement",
        "• For questions, contact info@retionzcabs.lk"
      ];
      
      terms.forEach((term, index) => {
        doc.text(term, 25, y + 5 + (index * 3.5));
      });

      // Footer
      const footerY = pageHeight - 15;
      doc.setFontSize(8);
      doc.setTextColor(100, 100, 100);
      doc.setFont("helvetica", "italic");
      doc.text("Thank you for your business!", pageWidth / 2, footerY - 5, { align: "center" });
      doc.text("Retionz Cabs & Rent A Car", pageWidth / 2, footerY, { align: "center" });

      // Save with professional filename
      const fileName = `Invoice-${invoiceNo}-${invoiceData.customerName?.replace(/\s+/g, '_') || 'Customer'}.pdf`;
      doc.save(fileName);

    } catch (error) {
      console.error("Error generating PDF:", error);
      // Fallback: Generate a simple PDF
      doc.text("Invoice Generation Error - Please try again", 20, 20);
      doc.save("invoice-error.pdf");
    }
  };

  // Error handling for logo
  logo.onerror = () => {
    console.warn("Logo failed to load, generating invoice without logo");
    // Generate basic invoice without logo
    doc.text("INVOICE", 20, 20);
    doc.text(`Invoice Number: ${invoiceData.invoiceNumber || "N/A"}`, 20, 30);
    doc.text(`Customer: ${invoiceData.customerName || "N/A"}`, 20, 40);
    doc.text(`Total: Rs. ${invoiceData.totalAmount || "0"}`, 20, 50);
    doc.save(`invoice-${invoiceData.invoiceNumber || "basic"}.pdf`);
  };
};



  const resetForm = () => {
    setFormData({
      companyName: 'Rentionz Cabs & Rent A Car',
      companyAddress: 'Maharagama Rd, Piliyandala 10300, Sri Lanka',
      companyPhone: '+94 70 170 7707',
      companyEmail: 'info@retionzcabs.lk',
      customerName: '',
      customerAddress: '',
      customerPhone: '',
      customerEmail: '',
      invoiceDate: new Date().toISOString().split('T')[0],
      rentalItems: [
        {
          vehicleDescription: '',
          dateRange: { startDate: new Date(), endDate: new Date() },
          ratePerDay: 0,
          numberOfDays: 1,
          numberOfKms: 0,
          extraCharges: 0,
          subtotal: 0
        }
      ],
      totalAmount: 0,
      paymentMethod: 'card',
      cardNumber: '',
      cardType: 'visa',
      paymentDate: new Date().toISOString().split('T')[0],
      chequeNumber: '',
      chequeDate: ''
    });
    setShowRangePickerIndex(null);
  };


const safeFormat = (d, fmt = 'yyyy-MM-dd') => {
  try {
    if (!d) return '-';
    const date = (typeof d === 'string' || typeof d === 'number') ? new Date(d) : d;
    if (!(date instanceof Date) || isNaN(date)) return '-';
    return format(date, fmt);
  } catch {
    return '-';
  }
};



///////////////////////////////////////////////// view invoices ///////////////////////////////////////////////////////////////////


  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const q = query(collection(db, "invoices"), orderBy("invoiceDate", "desc"));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const data = [];
      snapshot.forEach((doc) => data.push({ id: doc.id, ...doc.data() }));
      setInvoices(data);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  const handleDelete = async (id) => {
    try {
      await deleteDoc(doc(db, "invoices", id));
      message.success("Invoice deleted successfully");
    } catch (err) {
      console.error(err);
      message.error("Failed to delete invoice");
    }
  };

  const columns = [
    {
      title: "Invoice No.",
      dataIndex: "invoiceNumber",
      key: "invoiceNumber",
      render: (text) => text || "-",
    },
    {
      title: "Invoice Date",
      dataIndex: "invoiceDate",
      key: "invoiceDate",
      render: (text) => text ? new Date(text).toLocaleDateString() : "-",
    },

    {
      title: "Customer Name",
      dataIndex: "customerName",
      key: "customerName",
      render: (text) => text || "-",
    },
    {
      title: "Phone",
      dataIndex: "customerPhone",
      key: "customerPhone",
      render: (text) => text || "-",
    },
    {
      title: "Address",
      dataIndex: "customerAddress",
      key: "customerAddress",
      render: (text) => text || "-",
    },
    {
      title: "Total Amount",
      dataIndex: "totalAmount",
      key: "totalAmount",
      render: (num) => `Rs. ${Number(num || 0).toLocaleString("en-US", { maximumFractionDigits: 2 })}`,
    },
    {
      title: "Payment Method",
      dataIndex: "paymentMethod",
      key: "paymentMethod",
      render: (text) => text ? text.toUpperCase() : "-",
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <div style={{ display: "flex", gap: "8px" }}>
          <Button
            type="primary"
            icon={<DownloadOutlined />}
            onClick={() => generatePDF(record)}
          >
            Download
          </Button>
          <Popconfirm
            title="Are you sure to delete this invoice?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="danger" className="delete-btn-custom" icon={<DeleteOutlined />}>
              Delete
            </Button>
          </Popconfirm>
        </div>
      ),
    },
  ];
 

//////////////////////////////////////////////////  create booking confirmation ////////////////////////////////////////////////////////////////////

const [formDataConfirmation, setFormDataConfirmation] = useState({
  confirmationId: `RTZ-${Date.now()}`,
  customerName: "",
  customerPhone: "",
  vehicleType: "",
  rentalType: "Daily", // daily or monthly
  releaseDate: new Date().toISOString().split("T")[0],
  receiveDate: new Date().toISOString().split("T")[0],
  rate: "",
  deposit: ""
});
const [isSavingConfirmation, setIsSavingConfirmation] = useState(false);

const handleInputChangeConfirmation = (e) => {
  const { name, value } = e.target;
  setFormDataConfirmation((prev) => ({ ...prev, [name]: value }));
};


const saveBookingAndDownload = async () => {
  if (!formDataConfirmation.customerName || !formDataConfirmation.customerPhone) {
    alert("Please enter customer name and contact number.");
    return;
  }
  setIsSavingConfirmation(true);
  try {
    const payload = {
      ...formDataConfirmation,
      createdAt: serverTimestamp()
    };
    await addDoc(collection(db, "confirmations"), payload);

    generateBookingConfirmationPDF(payload);
  } catch (err) {
    console.error(err);
    alert("Failed to save booking. See console.");
  } finally {
    setIsSavingConfirmation(false);
  }
};


const generateBookingConfirmationPDF = (data) => {
  const doc = new jsPDF({
    format: "a5",
    orientation: "portrait",
    unit: "mm"
  });

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  // Professional color palette
  const primaryColor = [0, 32, 96];      // Navy Blue
  const secondaryColor = [230, 230, 250]; // Lavender
  const accentColor = [255, 215, 0];      // Gold
  const textDark = [51, 51, 51];          // Dark Gray
  const textLight = [255, 255, 255];      // White

  const logo = new Image();
  logo.crossOrigin = "Anonymous";
  logo.src = process.env.PUBLIC_URL + "/logo192.png";

  logo.onload = () => {
    // Add subtle background pattern
    doc.setFillColor(...secondaryColor);
    doc.rect(0, 0, pageWidth, pageHeight, "F");
    
    // Main header with gradient effect
    doc.setFillColor(...primaryColor);
    doc.roundedRect(5, 5, pageWidth - 10, 35, 3, 3, "F");
    
    // Company logo
    doc.addImage(logo, "PNG", 12, 10, 25, 25);
    
    // Company information with enhanced typography
    doc.setTextColor(...textLight);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.text("RETIONZ CABS & RENT A CAR (PVT) LTD", 45, 15);
    
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.text("Maharagama Rd, Piliyandala 10300, Sri Lanka", 45, 21);
    doc.text("+94 701 707 707 | info@retionzcabs.lk | www.retionzcabs.lk", 45, 27);
    
    // Decorative accent line
    doc.setDrawColor(...accentColor);
    doc.setLineWidth(0.5);
    doc.line(45, 30, pageWidth - 15, 30);
    
    // Main content container
    doc.setFillColor(...textLight);
    doc.roundedRect(10, 45, pageWidth - 20, pageHeight - 80, 5, 5, "F");
    doc.setDrawColor(200, 200, 200);
    doc.setLineWidth(0.2);
    doc.roundedRect(10, 45, pageWidth - 20, pageHeight - 80, 5, 5, "S");
    
    // Title with decorative elements
    doc.setTextColor(...primaryColor);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(18);
    doc.text("BOOKING CONFIRMATION", pageWidth / 2, 60, { align: "center" });
    
    // Decorative lines around title
    doc.setDrawColor(...accentColor);
    doc.setLineWidth(0.3);
    doc.line(pageWidth / 2 - 45, 62, pageWidth / 2 - 15, 62);
    doc.line(pageWidth / 2 + 15, 62, pageWidth / 2 + 45, 62);
    
    // Booking details section
    let y = 75;
    const safeText = (val) => val?.toString().trim() || "-";
    
    const fields = [
      { label: "CONFIRMATION ID", value: data.confirmationId || `RTZ-${Date.now()}` },
      { label: "CUSTOMER NAME", value: data.customerName },
      { label: "CONTACT NUMBER", value: data.customerPhone },
      { label: "EMAIL ADDRESS", value: data.customerEmail || "-" },
      { label: "VEHICLE TYPE", value: data.vehicleType },
      { label: "RENTAL TYPE", value: data.rentalType },
      { label: "RELEASE DATE", value: data.releaseDate },
      { label: "RETURN DATE", value: data.receiveDate },
      { label: "RATE", value: data.rate ? `Rs. ${Number(data.rate).toLocaleString()}` : "-" },
      { label: "DEPOSIT", value: data.deposit ? `Rs. ${Number(data.deposit).toLocaleString()}` : "-" },
      { label: "TOTAL AMOUNT", value: data.totalAmount ? `Rs. ${Number(data.totalAmount).toLocaleString()}` : "-" }
    ];
    
    fields.forEach((field, index) => {
      const isHighlighted = index === 0 || index === fields.length - 1;
      
      if (isHighlighted) {
        doc.setFillColor(245, 245, 255);
        doc.roundedRect(15, y - 4, pageWidth - 30, 6, 2, 2, "F");
      }
      
      doc.setFont("helvetica", "bold");
      doc.setTextColor(...primaryColor);
      doc.setFontSize(8);
      doc.text(field.label, 20, y);
      
      doc.setFont("helvetica", "normal");
      doc.setTextColor(...textDark);
      doc.setFontSize(9);
      doc.text(safeText(field.value), 65, y);
      
      y += 7;
    });
    
    // Terms and conditions section
    y += 5;
    doc.setFont("helvetica", "bold");
    doc.setTextColor(...primaryColor);
    doc.setFontSize(9);
    doc.text("TERMS & CONDITIONS:", 20, y);
    
    doc.setFont("helvetica", "normal");
    doc.setTextColor(...textDark);
    doc.setFontSize(7);
    const terms = [
      "• Booking confirmation subject to vehicle availability",
      "• Cancellation must be made 03 days prior to release date",
      "• Security deposit refundable upon vehicle return in good condition",
      "• Additional charges apply for extra mileage and late returns"
    ];
    
    terms.forEach(term => {
      y += 4;
      doc.text(term, 25, y, { maxWidth: pageWidth - 45 });
    });
    
    // // Watermark
    // doc.setGState(new doc.GState({ opacity: 0.03 }));
    // doc.setTextColor(...primaryColor);
    // doc.setFontSize(40);
    // doc.setFont("helvetica", "bold");
    // doc.text("CONFIRMED", pageWidth / 2, pageHeight / 2, { 
    //   align: "center",
    //   angle: 45 
    // });
    doc.setGState(new doc.GState({ opacity: 1 }));
    
    // Footer
    doc.setFillColor(...primaryColor);
    doc.roundedRect(5, pageHeight - 20, pageWidth - 10, 15, 3, 3, "F");
    
    doc.setTextColor(...textLight);
    doc.setFont("helvetica", "italic");
    doc.setFontSize(8);
    doc.text("Thank you for choosing Retionz Cabs & Rent A Car!", 
             pageWidth / 2, pageHeight - 15, { align: "center" });
    
    // Footer decoration
    doc.setDrawColor(...accentColor);
    doc.setLineWidth(0.3);
    doc.line(pageWidth / 2 - 60, pageHeight - 14, pageWidth / 2 + 60, pageHeight - 14);
    
    // Save with timestamp
    const timestamp = new Date().toISOString().split('T')[0];
    const fileName = `Retionz-Booking-${data.customerName?.replace(/\s+/g, '_') || 'Customer'}-${timestamp}.pdf`;
    
    doc.save(fileName);
  };

  // Handle logo loading errors
  logo.onerror = () => {
    console.warn("Logo failed to load, generating PDF without logo");
    // Regenerate without logo (you could implement a fallback version here)
  };
};


//////////////////////////////////////////////// view All Bookings/////////////////////////////////////////////////////////////////////
const [searchText, setSearchText] = useState("");
const [filterYear, setFilterYear] = useState("");
const [filterMonth, setFilterMonth] = useState("");
const [filterDay, setFilterDay] = useState("");

const [bookings, setBookings] = useState([]);
const [loadingBookings, setLoadingBookings] = useState(true);

// Fetch bookings from Firestore (latest first)
useEffect(() => {
  const q = query(
    collection(db, "confirmations"),
    orderBy("createdAt", "desc")
  );

  const unsubscribe = onSnapshot(q, (snapshot) => {
    const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setBookings(data);
    setLoadingBookings(false);
  });

  return () => unsubscribe();
}, []);



const filteredBookings = bookings.filter((b) => {
  const date = b.releaseDate ? new Date(b.releaseDate) : null;
  const year = date ? date.getFullYear().toString() : "";
  const month = date ? (date.getMonth() + 1).toString().padStart(2, "0") : "";
  const day = date ? date.getDate().toString().padStart(2, "0") : "";

  return (
    (!filterYear || filterYear === year) &&
    (!filterMonth || filterMonth === month) &&
    (!filterDay || filterDay === day) &&
    (b.vehicleType || "").toLowerCase().includes(searchText.toLowerCase())
  );
});

const clearFilters = () => {
  setSearchText("");
  setFilterYear("");
  setFilterMonth("");
  setFilterDay("");
};

const deleteBooking = async (id) => {
  if (window.confirm("Are you sure you want to delete this booking?")) {
    try {
      await deleteDoc(doc(db, "confirmations", id));
      alert("Booking deleted successfully.");
    } catch (err) {
      console.error(err);
      alert("Failed to delete booking.");
    }
  }
};





//////////////////////////////////////////////////////////  sales report ////////////////////////////////////////////////////////////////////


// State variables
const [reportType, setReportType] = useState('daily');
const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
const [selectedMonth, setSelectedMonth] = useState(new Date().toISOString().slice(0, 7));
const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
const [startDate, setStartDate] = useState('');
const [endDate, setEndDate] = useState('');
const [salesData, setSalesData] = useState([]);
const [chartType, setChartType] = useState('bar');
const [searchTerm, setSearchTerm] = useState('');
const [currentPage, setCurrentPage] = useState(1);
const [itemsPerPage, setItemsPerPage] = useState(10);

// Calculate metrics
const totalRevenue = salesData.reduce((sum, invoice) => sum + Number(invoice.totalAmount || 0), 0);
const totalInvoices = salesData.length;
const averageInvoice = totalInvoices > 0 ? totalRevenue / totalInvoices : 0;
const totalVehicles = salesData.reduce((sum, invoice) => sum + (invoice.rentalItems?.length || 0), 0);

// Filter invoices based on search
const filteredInvoices = salesData.filter(invoice => 
  invoice.invoiceNumber?.toLowerCase().includes(searchTerm.toLowerCase()) ||
  invoice.customerName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
  invoice.customerPhone?.includes(searchTerm)
);

// Pagination
const currentInvoices = filteredInvoices.slice(
  (currentPage - 1) * itemsPerPage,
  currentPage * itemsPerPage
);

// Firebase data fetching function
const generateReport = async () => {
  try {
    setLoading(true);
    const invoicesRef = collection(db, 'invoices');
    let q;

    switch (reportType) {
      case 'daily':
        const dailyStart = new Date(selectedDate);
        const dailyEnd = new Date(selectedDate);
        dailyEnd.setDate(dailyEnd.getDate() + 1);
        
        q = query(
          invoicesRef,
          where('invoiceDate', '>=', selectedDate),
          where('invoiceDate', '<', dailyEnd.toISOString().split('T')[0]),
          orderBy('invoiceDate', 'desc')
        );
        break;

      case 'monthly':
        const monthStart = `${selectedMonth}-01`;
        const monthEnd = new Date(selectedMonth + '-01');
        monthEnd.setMonth(monthEnd.getMonth() + 1);
        
        q = query(
          invoicesRef,
          where('invoiceDate', '>=', monthStart),
          where('invoiceDate', '<', monthEnd.toISOString().split('T')[0]),
          orderBy('invoiceDate', 'desc')
        );
        break;

      case 'yearly':
        const yearStart = `${selectedYear}-01-01`;
        const yearEnd = `${selectedYear}-12-31`;
        
        q = query(
          invoicesRef,
          where('invoiceDate', '>=', yearStart),
          where('invoiceDate', '<=', yearEnd),
          orderBy('invoiceDate', 'desc')
        );
        break;

      case 'custom':
        if (startDate && endDate) {
          q = query(
            invoicesRef,
            where('invoiceDate', '>=', startDate),
            where('invoiceDate', '<=', endDate),
            orderBy('invoiceDate', 'desc')
          );
        } else {
          q = query(invoicesRef, orderBy('invoiceDate', 'desc'));
        }
        break;

      default:
        q = query(invoicesRef, orderBy('invoiceDate', 'desc'));
    }

    const querySnapshot = await getDocs(q);
    const invoicesData = [];
    
    querySnapshot.forEach((doc) => {
      invoicesData.push({ id: doc.id, ...doc.data() });
    });

    setSalesData(invoicesData);
    setCurrentPage(1);
  } catch (error) {
    console.error('Error fetching sales data:', error);
    alert('Error fetching sales data. Please check console for details.');
  } finally {
    setLoading(false);
  }
};

// Load initial data
useEffect(() => {
  generateReport();
}, []);

// Export to Excel function
const exportToExcel = () => {
  const excelData = salesData.map(invoice => ({
    'Invoice Number': invoice.invoiceNumber || 'N/A',
    'Customer Name': invoice.customerName || 'N/A',
    'Customer Phone': invoice.customerPhone || 'N/A',
    'Customer Email': invoice.customerEmail || 'N/A',
    'Invoice Date': invoice.invoiceDate || 'N/A',
    'Payment Date': invoice.paymentDate || 'N/A',
    'Payment Method': invoice.paymentMethod?.toUpperCase() || 'N/A',
    'Total Amount': `Rs. ${Number(invoice.totalAmount || 0).toLocaleString()}`,
    'Number of Vehicles': invoice.rentalItems?.length || 0,
    'Total Rental Days': invoice.rentalItems?.reduce((sum, item) => sum + (item.numberOfDays || 0), 0) || 0,
    'Company': invoice.companyName || 'N/A',
    'Status': 'Paid'
  }));

  const worksheet = XLSX.utils.json_to_sheet(excelData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sales Report');
  
  const fileName = `sales-report-${reportType}-${new Date().toISOString().split('T')[0]}.xlsx`;
  XLSX.writeFile(workbook, fileName);
};

// Chart data calculations
const getRevenueChartData = () => {
  if (reportType === 'daily') {
    // Group by hour for daily report
    const hourlyData = Array.from({ length: 24 }, (_, i) => ({
      hour: i,
      revenue: 0
    }));

    salesData.forEach(invoice => {
      const hour = new Date(invoice.createdAt?.toDate()).getHours();
      hourlyData[hour].revenue += Number(invoice.totalAmount || 0);
    });

    return {
      labels: hourlyData.map(d => `${d.hour}:00`),
      data: hourlyData.map(d => d.revenue)
    };
  } else if (reportType === 'monthly') {
    // Group by day for monthly report
    const daysInMonth = new Date(selectedMonth.split('-')[0], selectedMonth.split('-')[1], 0).getDate();
    const dailyData = Array.from({ length: daysInMonth }, (_, i) => ({
      day: i + 1,
      revenue: 0
    }));

    salesData.forEach(invoice => {
      const day = new Date(invoice.invoiceDate).getDate();
      if (day <= daysInMonth) {
        dailyData[day - 1].revenue += Number(invoice.totalAmount || 0);
      }
    });

    return {
      labels: dailyData.map(d => `Day ${d.day}`),
      data: dailyData.map(d => d.revenue)
    };
  } else {
    // Group by month for yearly report
    const monthlyData = Array.from({ length: 12 }, (_, i) => ({
      month: i,
      revenue: 0
    }));

    salesData.forEach(invoice => {
      const month = new Date(invoice.invoiceDate).getMonth();
      monthlyData[month].revenue += Number(invoice.totalAmount || 0);
    });

    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return {
      labels: monthNames,
      data: monthlyData.map(d => d.revenue)
    };
  }
};

const getPaymentMethodData = () => {
  const paymentMethods = {};
  
  salesData.forEach(invoice => {
    const method = invoice.paymentMethod || 'unknown';
    paymentMethods[method] = (paymentMethods[method] || 0) + 1;
  });

  return {
    labels: Object.keys(paymentMethods).map(method => method.toUpperCase()),
    data: Object.values(paymentMethods),
    revenues: Object.keys(paymentMethods).map(method => 
      salesData
        .filter(inv => (inv.paymentMethod || 'unknown') === method)
        .reduce((sum, inv) => sum + Number(inv.totalAmount || 0), 0)
    )
  };
};

const getVehiclePerformanceData = () => {
  const vehiclePerformance = {};
  
  salesData.forEach(invoice => {
    invoice.rentalItems?.forEach(item => {
      const vehicle = item.vehicleDescription || 'Unknown Vehicle';
      if (!vehiclePerformance[vehicle]) {
        vehiclePerformance[vehicle] = {
          count: 0,
          revenue: 0,
          days: 0
        };
      }
      vehiclePerformance[vehicle].count++;
      vehiclePerformance[vehicle].revenue += Number(item.subtotal || 0);
      vehiclePerformance[vehicle].days += Number(item.numberOfDays || 0);
    });
  });

  const sortedVehicles = Object.entries(vehiclePerformance)
    .sort(([, a], [, b]) => b.revenue - a.revenue)
    .slice(0, 10); // Top 10 vehicles

  return {
    labels: sortedVehicles.map(([vehicle]) => vehicle),
    revenues: sortedVehicles.map(([, data]) => data.revenue),
    rentals: sortedVehicles.map(([, data]) => data.count),
    days: sortedVehicles.map(([, data]) => data.days)
  };
};

// Chart rendering functions
const renderRevenueChart = () => {
  const chartData = getRevenueChartData();
  
  return (
    <div className="chart-placeholder">
      <h4>Revenue Distribution</h4>
      <div className="chart-bars">
        {chartData.data.map((value, index) => (
          <div key={index} className="chart-bar-container">
            <div className="chart-bar-label">{chartData.labels[index]}</div>
            <div className="chart-bar">
              <div 
                className="chart-bar-fill"
                style={{ 
                  height: `${(value / Math.max(...chartData.data)) * 100}%`,
                  backgroundColor: '#002060'
                }}
              ></div>
            </div>
            <div className="chart-bar-value">
              Rs. {value.toLocaleString()}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const renderPaymentMethodChart = () => {
  const paymentData = getPaymentMethodData();
  
  return (
    <div className="payment-chart">
      <h4>Payment Methods</h4>
      <div className="payment-methods-list">
        {paymentData.labels.map((method, index) => (
          <div key={method} className="payment-method-item">
            <div className="payment-method-header">
              <span className="method-name">{method}</span>
              <span className="method-count">{paymentData.data[index]} invoices</span>
            </div>
            <div className="payment-method-revenue">
              Rs. {paymentData.revenues[index].toLocaleString()}
            </div>
            <div className="payment-method-bar">
              <div 
                className="method-bar-fill"
                style={{
                  width: `${(paymentData.data[index] / Math.max(...paymentData.data)) * 100}%`,
                  backgroundColor: method === 'CASH' ? '#10b981' : 
                                 method === 'CARD' ? '#3b82f6' : 
                                 method === 'CHEQUE' ? '#f59e0b' : '#6b7280'
                }}
              ></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const renderVehiclePerformanceChart = () => {
  const vehicleData = getVehiclePerformanceData();
  
  return (
    <div className="vehicle-performance">
      <h4>Top Performing Vehicles</h4>
      <div className="vehicle-list">
        {vehicleData.labels.map((vehicle, index) => (
          <div key={vehicle} className="vehicle-item">
            <div className="vehicle-info">
              <div className="vehicle-name">{vehicle}</div>
              <div className="vehicle-stats">
                <span className="stat">{vehicleData.rentals[index]} rentals</span>
                <span className="stat">{vehicleData.days[index]} days</span>
              </div>
            </div>
            <div className="vehicle-revenue">
              Rs. {vehicleData.revenues[index].toLocaleString()}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

// Utility functions
const viewInvoice = (invoice) => {
  // Open invoice in modal or new page
  console.log('View invoice:', invoice);
  // You can implement a modal here to show invoice details
  alert(`Invoice Details:\n\nCustomer: ${invoice.customerName}\nAmount: Rs. ${invoice.totalAmount}\nDate: ${invoice.invoiceDate}`);
};

const downloadInvoice = async (invoice) => {
  try {
    // Reuse your existing PDF generation function
    await generatePDF(invoice);
  } catch (error) {
    console.error('Error downloading invoice:', error);
    alert('Error downloading invoice. Please try again.');
  }
};

const refreshData = () => {
  generateReport();
};

// Add this to your component return to show loading state
{loading && (
  <div className="loading-overlay">
    <div className="loading-spinner"></div>
    <p>Generating sales report...</p>
  </div>
)}
  





///////////////////////////////////////////////////// create agreement //////////////////////////////////////////////////////////////////

  // --- form state (all fields to save) ---
  const [form, setForm] = useState({
    place: "",
    agreementDay: "",
    agreementMonth: "",
    agreementYear: "",

    lesseeFullName: "",
    lesseeNIC: "",
    lesseeAddress: "",
    lesseeTelephone: "",
    lesseeLandline: "",

    vehicleRegNo: "",
    vehicleType: "",
    rentalPeriodStart: "",
    rentalPeriodEnd: "",
    withDriver: "without", // "with" or "without"

    paymentAmountWords: "",
    paymentAmountFigure: "",
    maxKm: "",
    extraKmRateWords: "",
    extraKmRateFigure: "",
    securityDeposit: "",
    meterReading: "",
    lesseeUsePurpose: "",

    suretyFullName: "",
    suretyNIC: "",
    suretyAddress: "",
    suretyTelephone: "",
    suretyRelationship: ""
  });

  const [saving, setSaving] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  // Save only entered data to Firestore
  const saveAgreementToFirestore = async (data) => {
    setSaving(true);
    try {
      const docRef = await addDoc(collection(db, "agreements"), {
        ...data,
        createdAt: serverTimestamp()
      });
      setSaving(false);
      return docRef.id;
    } catch (err) {
      setSaving(false);
      console.error("Error saving agreement:", err);
      throw err;
    }
  };

  // Generate PDF from template + form data (template remains in React)
  const generatePDFAgreement = (data) => {
    const doc = new jsPDF({ unit: "pt", format: "a4" });
    const left = 40;
    const pageWidth = doc.internal.pageSize.getWidth();
    const maxLineWidth = pageWidth - left * 2;
    const lineHeight = 14;
    let cursorY = 40;

    const write = (txt, opts = {}) => {
      const { style = "normal", align = "left", fontSize = 11 } = opts;
      doc.setFont("Times", style);
      doc.setFontSize(fontSize);

      const lines = doc.splitTextToSize(txt, maxLineWidth);
      doc.text(lines, left, cursorY, { align });
      cursorY += lines.length * (lineHeight);
      // new page if overflow
      if (cursorY > doc.internal.pageSize.getHeight() - 60) {
        doc.addPage();
        cursorY = 40;
      }
    };


    

// ==== HEADER START ====

// Load logo from public folder
const logo = `${process.env.PUBLIC_URL}/logo192.png`;

// Draw header background bar
doc.setFillColor(0, 32, 96);
doc.roundedRect(10, 10, pageWidth - 20, 55, 5, 5, "F");

// Add logo (auto-loads from public folder)
doc.addImage(logo, "PNG", 20, 15, 40, 40);

// Set text color to white for header
doc.setTextColor(255, 255, 255);

// Company name
doc.setFont("helvetica", "bold");
doc.setFontSize(14);
doc.text("RETIONZ CABS & RENT A CAR (PVT) LTD", 70, 28);

// Company address + contacts
doc.setFont("helvetica", "normal");
doc.setFontSize(10);
doc.text("Maharagama Rd, Piliyandala 10300, Sri Lanka", 70, 42);
doc.text("+94 701 707 707   |   info@retionzcabs.lk   |   www.retionzcabs.lk", 70, 54);

// Reset text color for rest of document
doc.setTextColor(0, 0, 0);

// Move cursor below header
cursorY = 80;
  cursorY += 24;
// ==== HEADER END ====
  doc.setFontSize(14);
    doc.setFont("Times", "bold");
    doc.text("VEHICLE RENTAL AGREEMENT", pageWidth / 2, cursorY, { align: "center" });
    cursorY += 24;








    doc.setFontSize(11);

    doc.setFont("Times", "normal");

    // Intro line with filled bits
    const intro = `THIS VEHICLE RENTAL AGREEMENT is made and entered into at ${data.place || "___________"} on this ${data.agreementDay || "____"} day of ${data.agreementMonth || "___________"}, ${data.agreementYear || "_______"}, by and between RETIONZ CABS AND RENT A CAR (PVT) LTD of No. 180/6, Mihira Mawatha, Makuluduwa, Piliyandala (hereinafter referred to as the “VEHICLE OWNER”), and ${data.lesseeFullName || "______________________________"} (N.I.C. No. ${data.lesseeNIC || "______"}) of ${data.lesseeAddress || "___________________________"} (hereinafter referred to as the “LESSEE”), with regard to the rental of the vehicle bearing Registration No. ${data.vehicleRegNo || "__________"}, owned by the said Vehicle Owner, to the said Lessee for a period of ${data.rentalPeriodStart || "__________"} commencing from ${data.rentalPeriodStart || "_________"} and ending on ${data.rentalPeriodEnd || "______________"}, (${data.withDriver === "with" ? "with" : "without"}) a driver, subject to the terms and conditions set out hereinafter.`;

    write(intro);

    // Now add numbered clauses (I'll include the main clauses and inject data where appropriate)
    const clauses = [
      `1. The Lessee agrees to pay a sum of Rupees ${data.paymentAmountWords || "_____________"} (Rs. ${data.paymentAmountFigure || "____"}) in cash to the Vehicle Owner.`,
      `2. The Lessee shall drive a maximum of ${data.maxKm || "_____________"} kilometers per month/day.`,
      `3. The Lessee agrees to pay a sum of Rupees ${data.extraKmRateWords || "_____________"} (Rs. ${data.extraKmRateFigure || "____"}) per every extra kilometer driven, without fuel, to the Vehicle Owner.`,
      `4. The Lessee agrees to reinstate the Vehicle to its original condition if the Lessee or his agent causes any damage...`, // shortened for compactness
      `5. In the event of an accident, insurance will not be claimed for damage up to Rs. 30,000/-, and the Lessee agrees to pay such damage.`,
      `6. In the event of an accident, a sum of Rs. 20,000/- and the insurance cost will be claimed from the Lessee...`,
      `7. The Lessee shall repair all damage caused to the Vehicle resulting from the Lessee’s negligence, drunk driving, or theft of any items removed from the Vehicle by the thieves.`,
      `8. The Lessee shall furnish a security deposit of Rupees ${data.securityDeposit || "____________"} to the Vehicle Owner as security for any other risks or liabilities that may arise...`,
      `9. The Lessee is prohibited from retaining the Vehicle in his possession beyond the rental period stipulated herein...`,
      `10. Subject to this Agreement, upon the Lessee returning the Vehicle to the satisfaction of the Vehicle Owner, the Vehicle Owner shall release the said security deposit to the Lessee either by cheque or in cash...`,
      `11. The Lessee agrees to use the Vehicle solely for the following purposes: ${data.lesseeUsePurpose || "........................................"}`,
      `12. The Lessee is strictly prohibited from using the Vehicle for any purpose other than those specified above (clause 11).`,
      `13. The Vehicle Owner shall not be liable for any inconvenience or loss caused due to any disaster or unforeseen event occurring during the use of the Vehicle...`,
      `14. The Lessee shall return the Vehicle on the final day of the rental period before 6.00 p.m., and in the event of a delay beyond 6.00 p.m., the Lessee shall be liable to pay a sum of Rs. 300/- per hour to the Vehicle Owner.`,
      `15. In the event it is established that the meter cable, socket, or meter board has been removed, tampered with, or altered, the security deposit shall be forfeited and shall not be released to the Lessee. Meter Reading: ${data.meterReading || "…………………"}  Signature of the Lessee:…………………`,
      // (Clauses 16–28 kept as template text)
      `16. If the Lessee fails to make full payment as agreed at the time of returning the Vehicle, the outstanding amount shall be deducted from the security deposit...`,
      `17. The Lessee agrees to return to the Vehicle Owner the identical Vehicle handed over to him, as described in the Certificate of Registration of the Vehicle.`,
      `18. If the Lessee intends to carry out any repair whatsoever, the Lessee shall obtain the prior written approval of the Vehicle Owner.`,
      `19. The Vehicle Owner shall carry out routine services such as servicing the Vehicle and changing tyres, and the Lessee agrees to attend to emergency repairs not exceeding Rs. 5,000/-.`,
      `20. If any mechanical fault arises while driving the Vehicle, the Lessee shall immediately notify the Vehicle Owner and act according to the instructions issued by the Vehicle Owner...`,
      `21. The Lessee shall not lease, rent, or otherwise hand over the Vehicle to any third party...`,
      `22. After the Vehicle is rented to the Lessee, the full responsibility for the Vehicle shall lie with the Lessee...`,
      `23. The Lessee and his sureties shall be responsible for and shall bear all losses, liabilities, and damages arising from any illegal activities connected with the use of the Vehicle.`,
      `24. The Lessee shall not permit any person who is prohibited under the Motor Traffic Act or any other written law to drive the Vehicle.`,
      `25. If the Vehicle is seized, retained, or taken into custody by the Police or any lawful authority for any reason whatsoever, the Lessee shall bear all legal costs incurred in that regard.`,
      `26. If the insurance claim relating to an accident is rejected due to the fault or negligence of the Lessee, the Lessee shall bear the full cost required to reinstate the Vehicle to its original condition.`,
      `27. If the Lessee fails and/or neglects to pay the rental on time, the Lessee shall pay an additional sum of Rs. 1,000/- per day, in addition to the rental.`,
      `28. Even if the Vehicle is returned to the Vehicle Owner prior to the expiry of the rental period, the security deposit shall be released only upon the expiration and completion of the Agreement on the relevant date.`,
      `The Lessee agrees to duly comply with and perform all terms and conditions set out above from Clause 01 to Clause 28.`,
      `I, ${data.lesseeFullName || "________________________________"}, having read and fully understood the above terms and conditions, hereby sign this Vehicle Rental Agreement at ${data.place || "_____________________"} at ______ (a.m./p.m.).`
    ];

    clauses.forEach((c) => write(c));

    // Details of Lessee
    write("Details of the Lessee", { style: "bold", fontSize: 12 });
    write(`1. Full Name : ${data.lesseeFullName || "……………………"}`);
    write(`2. N.I.C. No. : ${data.lesseeNIC || "……………………"}  Telephone No.: ${data.lesseeTelephone || "……………………"}`);
    write(`3. Landline No. : ${data.lesseeLandline || "……………………"}`);
    write(`4. Permanent Address : ${data.lesseeAddress || "……………………"}`);
    write(`5. Current address : ${data.lesseeAddress || "……………………"}`);

    // Surety
    write("Details of the Surety", { style: "bold", fontSize: 12 });
    write(`1. Full Name : ${data.suretyFullName || "……………………"}`);
    write(`2. N.I.C. No. : ${data.suretyNIC || "……………………"}`);
    write(`3. Permanent Address : ${data.suretyAddress || "……………………"}`);
    write(`4. Telephone No.: ${data.suretyTelephone || "……………………"}`);
    write(`5. Relationship to the Lessee : ${data.suretyRelationship || "……………………"}`);

    // Footer signatures placeholders
    cursorY += 20;
    write("Surety Signature : ______________________    Date : ______________", { fontSize: 11 });
    write("The Lessee: ______________________    Vehicle Owner: ______________________", { fontSize: 11 });

    return doc;
  };

  // When user clicks Save + Generate
  const handleSaveAndGenerate = async (e) => {
    e.preventDefault();
    try {
      // Save entered data only
      const docId = await saveAgreementToFirestore({ ...form });
      // Generate pdf (not saved to firestore)
      const pdf = generatePDFAgreement(form);
      pdf.save(`vehicle_agreement_${docId || Date.now()}.pdf`);
      alert("Agreement saved and PDF downloaded.");
      // Optionally reset form if you want:
      // setForm({...initial empty});
    } catch (err) {
      alert("Failed to save agreement. Check console for details.");
    }
  };








  //////////////////////////////////////////////// view all agreements////////////////////////////////////////////////////////////////

  const [agreements, setAgreements] = useState([]);
const [loadingAgreements, setLoadingAgreements] = useState(true);

useEffect(() => {
  const q = query(
    collection(db, "agreements"),
    orderBy("createdAt", "desc")
  );

  const unsub = onSnapshot(q, (snapshot) => {
    const data = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    setAgreements(data);
    setLoadingAgreements(false);
  });

  return () => unsub();
}, []);





  // Generate PDF from template + form data (template remains in React)
  const generateAgreementPDF = (data) => {
    const doc = new jsPDF({ unit: "pt", format: "a4" });
    const left = 40;
    const pageWidth = doc.internal.pageSize.getWidth();
    const maxLineWidth = pageWidth - left * 2;
    const lineHeight = 14;
    let cursorY = 40;

    const write = (txt, opts = {}) => {
      const { style = "normal", align = "left", fontSize = 11 } = opts;
      doc.setFont("Times", style);
      doc.setFontSize(fontSize);

      const lines = doc.splitTextToSize(txt, maxLineWidth);
      doc.text(lines, left, cursorY, { align });
      cursorY += lines.length * (lineHeight);
      // new page if overflow
      if (cursorY > doc.internal.pageSize.getHeight() - 60) {
        doc.addPage();
        cursorY = 40;
      }
    };








// ==== HEADER START ====

// Load logo from public folder
const logo = `${process.env.PUBLIC_URL}/logo192.png`;

// Draw header background bar
doc.setFillColor(0, 32, 96);
doc.roundedRect(10, 10, pageWidth - 20, 55, 5, 5, "F");

// Add logo (auto-loads from public folder)
doc.addImage(logo, "PNG", 20, 15, 40, 40);

// Set text color to white for header
doc.setTextColor(255, 255, 255);

// Company name
doc.setFont("helvetica", "bold");
doc.setFontSize(14);
doc.text("RETIONZ CABS & RENT A CAR (PVT) LTD", 70, 28);

// Company address + contacts
doc.setFont("helvetica", "normal");
doc.setFontSize(10);
doc.text("Maharagama Rd, Piliyandala 10300, Sri Lanka", 70, 42);
doc.text("+94 701 707 707   |   info@retionzcabs.lk   |   www.retionzcabs.lk", 70, 54);

// Reset text color for rest of document
doc.setTextColor(0, 0, 0);

// Move cursor below header
cursorY = 80;
  cursorY += 24;
// ==== HEADER END ====
  doc.setFontSize(14);
    doc.setFont("Times", "bold");
    doc.text("VEHICLE RENTAL AGREEMENT", pageWidth / 2, cursorY, { align: "center" });
    cursorY += 24;


    doc.setFontSize(11);

    doc.setFont("Times", "normal");

    // Intro line with filled bits
    const intro = `THIS VEHICLE RENTAL AGREEMENT is made and entered into at ${data.place || "___________"} on this ${data.agreementDay || "____"} day of ${data.agreementMonth || "___________"}, ${data.agreementYear || "_______"}, by and between RETIONZ CABS AND RENT A CAR (PVT) LTD of No. 180/6, Mihira Mawatha, Makuluduwa, Piliyandala (hereinafter referred to as the “VEHICLE OWNER”), and ${data.lesseeFullName || "______________________________"} (N.I.C. No. ${data.lesseeNIC || "______"}) of ${data.lesseeAddress || "___________________________"} (hereinafter referred to as the “LESSEE”), with regard to the rental of the vehicle bearing Registration No. ${data.vehicleRegNo || "__________"}, owned by the said Vehicle Owner, to the said Lessee for a period of ${data.rentalPeriodStart || "__________"} commencing from ${data.rentalPeriodStart || "_________"} and ending on ${data.rentalPeriodEnd || "______________"}, (${data.withDriver === "with" ? "with" : "without"}) a driver, subject to the terms and conditions set out hereinafter.`;

    write(intro);

    // Now add numbered clauses (I'll include the main clauses and inject data where appropriate)
    const clauses = [
      `1. The Lessee agrees to pay a sum of Rupees ${data.paymentAmountWords || "_____________"} (Rs. ${data.paymentAmountFigure || "____"}) in cash to the Vehicle Owner.`,
      `2. The Lessee shall drive a maximum of ${data.maxKm || "_____________"} kilometers per month/day.`,
      `3. The Lessee agrees to pay a sum of Rupees ${data.extraKmRateWords || "_____________"} (Rs. ${data.extraKmRateFigure || "____"}) per every extra kilometer driven, without fuel, to the Vehicle Owner.`,
      `4. The Lessee agrees to reinstate the Vehicle to its original condition if the Lessee or his agent causes any damage...`, // shortened for compactness
      `5. In the event of an accident, insurance will not be claimed for damage up to Rs. 30,000/-, and the Lessee agrees to pay such damage.`,
      `6. In the event of an accident, a sum of Rs. 20,000/- and the insurance cost will be claimed from the Lessee...`,
      `7. The Lessee shall repair all damage caused to the Vehicle resulting from the Lessee’s negligence, drunk driving, or theft of any items removed from the Vehicle by the thieves.`,
      `8. The Lessee shall furnish a security deposit of Rupees ${data.securityDeposit || "____________"} to the Vehicle Owner as security for any other risks or liabilities that may arise...`,
      `9. The Lessee is prohibited from retaining the Vehicle in his possession beyond the rental period stipulated herein...`,
      `10. Subject to this Agreement, upon the Lessee returning the Vehicle to the satisfaction of the Vehicle Owner, the Vehicle Owner shall release the said security deposit to the Lessee either by cheque or in cash...`,
      `11. The Lessee agrees to use the Vehicle solely for the following purposes: ${data.lesseeUsePurpose || "........................................"}`,
      `12. The Lessee is strictly prohibited from using the Vehicle for any purpose other than those specified above (clause 11).`,
      `13. The Vehicle Owner shall not be liable for any inconvenience or loss caused due to any disaster or unforeseen event occurring during the use of the Vehicle...`,
      `14. The Lessee shall return the Vehicle on the final day of the rental period before 6.00 p.m., and in the event of a delay beyond 6.00 p.m., the Lessee shall be liable to pay a sum of Rs. 300/- per hour to the Vehicle Owner.`,
      `15. In the event it is established that the meter cable, socket, or meter board has been removed, tampered with, or altered, the security deposit shall be forfeited and shall not be released to the Lessee. Meter Reading: ${data.meterReading || "…………………"}  Signature of the Lessee:…………………`,
      // (Clauses 16–28 kept as template text)
      `16. If the Lessee fails to make full payment as agreed at the time of returning the Vehicle, the outstanding amount shall be deducted from the security deposit...`,
      `17. The Lessee agrees to return to the Vehicle Owner the identical Vehicle handed over to him, as described in the Certificate of Registration of the Vehicle.`,
      `18. If the Lessee intends to carry out any repair whatsoever, the Lessee shall obtain the prior written approval of the Vehicle Owner.`,
      `19. The Vehicle Owner shall carry out routine services such as servicing the Vehicle and changing tyres, and the Lessee agrees to attend to emergency repairs not exceeding Rs. 5,000/-.`,
      `20. If any mechanical fault arises while driving the Vehicle, the Lessee shall immediately notify the Vehicle Owner and act according to the instructions issued by the Vehicle Owner...`,
      `21. The Lessee shall not lease, rent, or otherwise hand over the Vehicle to any third party...`,
      `22. After the Vehicle is rented to the Lessee, the full responsibility for the Vehicle shall lie with the Lessee...`,
      `23. The Lessee and his sureties shall be responsible for and shall bear all losses, liabilities, and damages arising from any illegal activities connected with the use of the Vehicle.`,
      `24. The Lessee shall not permit any person who is prohibited under the Motor Traffic Act or any other written law to drive the Vehicle.`,
      `25. If the Vehicle is seized, retained, or taken into custody by the Police or any lawful authority for any reason whatsoever, the Lessee shall bear all legal costs incurred in that regard.`,
      `26. If the insurance claim relating to an accident is rejected due to the fault or negligence of the Lessee, the Lessee shall bear the full cost required to reinstate the Vehicle to its original condition.`,
      `27. If the Lessee fails and/or neglects to pay the rental on time, the Lessee shall pay an additional sum of Rs. 1,000/- per day, in addition to the rental.`,
      `28. Even if the Vehicle is returned to the Vehicle Owner prior to the expiry of the rental period, the security deposit shall be released only upon the expiration and completion of the Agreement on the relevant date.`,
      `The Lessee agrees to duly comply with and perform all terms and conditions set out above from Clause 01 to Clause 28.`,
      `I, ${data.lesseeFullName || "________________________________"}, having read and fully understood the above terms and conditions, hereby sign this Vehicle Rental Agreement at ${data.place || "_____________________"} at ______ (a.m./p.m.).`
    ];

    clauses.forEach((c) => write(c));

    // Details of Lessee
    write("Details of the Lessee", { style: "bold", fontSize: 12 });
    write(`1. Full Name : ${data.lesseeFullName || "……………………"}`);
    write(`2. N.I.C. No. : ${data.lesseeNIC || "……………………"}  Telephone No.: ${data.lesseeTelephone || "……………………"}`);
    write(`3. Landline No. : ${data.lesseeLandline || "……………………"}`);
    write(`4. Permanent Address : ${data.lesseeAddress || "……………………"}`);
    write(`5. Current address : ${data.lesseeAddress || "……………………"}`);

    // Surety
    write("Details of the Surety", { style: "bold", fontSize: 12 });
    write(`1. Full Name : ${data.suretyFullName || "……………………"}`);
    write(`2. N.I.C. No. : ${data.suretyNIC || "……………………"}`);
    write(`3. Permanent Address : ${data.suretyAddress || "……………………"}`);
    write(`4. Telephone No.: ${data.suretyTelephone || "……………………"}`);
    write(`5. Relationship to the Lessee : ${data.suretyRelationship || "……………………"}`);

    // Footer signatures placeholders
    cursorY += 20;
    write("Surety Signature : ______________________    Date : ______________", { fontSize: 11 });
    write("The Lessee: ______________________    Vehicle Owner: ______________________", { fontSize: 11 });

return doc.save(`Agreement_${data.lesseeFullName || "document"}.pdf`);

  };







const deleteAgreement = async (id) => {
  if (window.confirm("Are you sure you want to delete this agreement?")) {
    try {
      await deleteDoc(doc(db, "agreements", id));
      alert("Agreement deleted successfully.");
    } catch (err) {
      console.error(err);
      alert("Failed to delete agreement.");
    }
  }
};






///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


return (


    <div className="hero-dashboard-container">
      {/* Left Sidebar */}
      <div className="lecturer-sidebar">
      <div className="home-content">
              <img
                src="/retionz-tire.png" // Assuming the image is in the public folder
                alt="Ranathunga Optical"
              
              />
              </div>
        <h2 className="lecturer-sidebar-title">Retionz Cabs</h2>

        <div className="lecturer-sidebar-list">
          <li onClick={() => setSelectedOption("bookingConfirmation")}>Booking Confirmation</li>
          <li onClick={() => setSelectedOption("viewBookingConfirmation")}>View All Booking Confirmation</li>
          <li onClick={() => setSelectedOption("createAgreement")}>Create Agreement</li>
          <li onClick={() => setSelectedOption("viewAgreements")}>View All Agreements</li>
          <li onClick={() => setSelectedOption("createInvoice")}>Create Invoice</li>
          <li onClick={() => setSelectedOption("viewInvoice")}>View All Invoice</li>
           <li onClick={() => setSelectedOption("salesReport")}>Sales Report</li>
          <li className="logout-button" onClick={handleLogout}>Logout</li>
        </div>
      </div>

      {/* Main Panel */}
      <div className="lecturer-panel">










{/************************************************** Create Booking Confirmation *************************************************************************/}




{selectedOption === "bookingConfirmation" && (
  <div className="booking-confirmation-container-main">
    <h1>Booking Confirmation</h1>

    <div className="booking-confirmation-form">
      {/* Row 1 */}
      <div className="form-group">
        <input
          type="text"
          name="customerName"
          placeholder="Customer Name"
          value={formDataConfirmation.customerName}
          onChange={handleInputChangeConfirmation}
        />
      </div>

      <div className="form-group">
        <input
          type="text"
          name="customerPhone"
          placeholder="Contact Number"
          value={formDataConfirmation.customerPhone}
          onChange={handleInputChangeConfirmation}
        />
      </div>

      {/* Row 2 */}
      <div className="form-group">
        <input
          type="text"
          name="vehicleType"
          placeholder="Vehicle Type"
          value={formDataConfirmation.vehicleType}
          onChange={handleInputChangeConfirmation}
        />
      </div>


      <div className="form-group">
        <select
          name="rentalType"
          value={formDataConfirmation.rentalType}
          onChange={handleInputChangeConfirmation}
        >
          <option value="Daily">Daily</option>
          <option value="Monthly">Monthly</option>
        </select>
      </div>


      {/* Row 3 */}
      <div className="form-group">
        <label>Release Date:</label>
        <input
          type="date"
          name="releaseDate"
          value={formDataConfirmation.releaseDate}
          onChange={handleInputChangeConfirmation}
        />
      </div>

      <div className="form-group">
        <label>Receive Date:</label>
        <input
          type="date"
          name="receiveDate"
          value={formDataConfirmation.receiveDate}
          onChange={handleInputChangeConfirmation}
        />
      </div>

      {/* Row 4 */}
      <div className="form-group">
        <input
          type="number"
          name="rate"
          placeholder="Rate"
          value={formDataConfirmation.rate}
          onChange={handleInputChangeConfirmation}
        />
      </div>

      <div className="form-group">
        <input
          type="number"
          name="deposit"
          placeholder="Deposit Amount"
          value={formDataConfirmation.deposit}
          onChange={handleInputChangeConfirmation}
        />
      </div>

      {/* Full Width Button */}
      <div className="form-group full-width">
        <button
          onClick={saveBookingAndDownload}
          disabled={isSavingConfirmation}
        >
          {isSavingConfirmation
            ? "Saving..."
            : "Save & Download Booking Confirmation"}
        </button>
      </div>
    </div>
  </div>
)}



{/************************************************** View All Booking Confirmation *************************************************************************/}


{selectedOption === "viewBookingConfirmation" && (
  <div className="view-all-booking-confirmation-container">
    <h1>View All Booking Confirmations</h1>



{/* FILTER BAR */}
<div className="filter-bar">
  <input
    type="text"
    placeholder="Search Vehicle Number..."
    className="filter-input"
    value={searchText}
    onChange={(e) => setSearchText(e.target.value)}
  />

  <select value={filterYear} onChange={(e) => setFilterYear(e.target.value)}>
    <option value="">Year</option>
    {Array.from({ length: 20 }, (_, i) => 2020 + i).map((yr) => (
      <option key={yr} value={yr}>{yr}</option>
    ))}
  </select>

  <select value={filterMonth} onChange={(e) => setFilterMonth(e.target.value)}>
    <option value="">Month</option>
    {[...Array(12)].map((_, i) => (
      <option key={i+1} value={(i+1).toString().padStart(2,"0")}>
        {new Date(0, i).toLocaleString("en", { month: "long" })}
      </option>
    ))}
  </select>

  <select value={filterDay} onChange={(e) => setFilterDay(e.target.value)}>
    <option value="">Day</option>
    {[...Array(31)].map((_, i) => (
      <option key={i+1} value={(i+1).toString().padStart(2,"0")}>{i+1}</option>
    ))}
  </select>

  {/* CLEAR BUTTON */}
  <button className="clear-filter-btn" onClick={clearFilters}>
    Clear
  </button>
</div>



    {loadingBookings ? (
      <p>Loading...</p>
    ) : filteredBookings.length === 0 ? (
      <p>No bookings found.</p>
    ) : (
      <table className="booking-table">
        <thead>
          <tr>
            <th>Confirmation ID</th>
            <th>Vehicle Type</th>
            <th>Customer Name</th>
            <th>Contact Number</th>
            <th>Vehicle Type</th>
            <th>Rental Type</th>
            <th>Release Date</th>
            <th>Receive Date</th>
            <th>Rate</th>
            <th>Deposit</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {filteredBookings.map((b) => (
            <tr key={b.id}>
              <td>{b.confirmationId || "-"}</td>
              <td>{b.vehicleType || "-"}</td>
              <td>{b.customerName || "-"}</td>
              <td>{b.customerPhone || "-"}</td>
              <td>{b.vehicleType || "-"}</td>
              <td>{b.rentalType || "-"}</td>
              <td>{b.releaseDate || "-"}</td>
              <td>{b.receiveDate || "-"}</td>
              <td>{b.rate ? `Rs. ${b.rate}` : "-"}</td>
              <td>{b.deposit ? `Rs. ${b.deposit}` : "-"}</td>
              <td>
                <button className="btn-download" onClick={() => generateBookingConfirmationPDF(b)}>Download</button>
                <button className="btn-delete" onClick={() => deleteBooking(b.id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    )}
  </div>
)}












{/************************************************** create agreement *************************************************************************/}

{  selectedOption === "createAgreement" && (
<div className="create-agreement-container">
  <h1>Create Agreement</h1>

  <form onSubmit={handleSaveAndGenerate} className="agreement-form">

    {/* TOP DETAILS */}
    <h3 className="section-title">Agreement Details</h3>

    <div className="form-group">
      <label>Place:</label>
      <input
        name="place"
        value={form.place}
        onChange={handleChange}
        className="form-input"
      />
    </div>

    <div className="flex-row">
      <div className="form-group">
        <label>Day:</label>
        <input
          name="agreementDay"
          value={form.agreementDay}
          onChange={handleChange}
          className="form-input"
        />
      </div>

      <div className="form-group">
        <label>Month:</label>
        <input
          name="agreementMonth"
          value={form.agreementMonth}
          onChange={handleChange}
          className="form-input"
        />
      </div>

      <div className="form-group">
        <label>Year:</label>
        <input
          name="agreementYear"
          value={form.agreementYear}
          onChange={handleChange}
          className="form-input"
        />
      </div>
    </div>

    <hr />

    {/* LESSEE DETAILS */}
    <h3 className="section-title">Lessee Details</h3>

    <div className="form-group">
      <label>Full Name:</label>
      <input
        name="lesseeFullName"
        value={form.lesseeFullName}
        onChange={handleChange}
        required
        className="form-input"
      />
    </div>

    <div className="form-group">
      <label>N.I.C. No:</label>
      <input
        name="lesseeNIC"
        value={form.lesseeNIC}
        onChange={handleChange}
        className="form-input"
      />
    </div>

    <div className="form-group">
      <label>Telephone No.:</label>
      <input
        name="lesseeTelephone"
        value={form.lesseeTelephone}
        onChange={handleChange}
        className="form-input"
      />
    </div>

    <div className="form-group">
      <label>Landline No.:</label>
      <input
        name="lesseeLandline"
        value={form.lesseeLandline}
        onChange={handleChange}
        className="form-input"
      />
    </div>

    <div className="form-group">
      <label>Permanent / Current Address:</label>
      <textarea
        name="lesseeAddress"
        value={form.lesseeAddress}
        onChange={handleChange}
        rows={3}
        className="form-textarea"
      />
    </div>

    <hr />

    {/* VEHICLE & RENTAL DETAILS */}
    <h3 className="section-title">Vehicle & Rental Details</h3>

    <div className="form-group">
      <label>Vehicle Registration No.:</label>
      <input
        name="vehicleRegNo"
        value={form.vehicleRegNo}
        onChange={handleChange}
        required
        className="form-input"
      />
    </div>

    <div className="form-group">
      <label>Vehicle Type:</label>
      <input
        name="vehicleType"
        value={form.vehicleType}
        onChange={handleChange}
        className="form-input"
      />
    </div>

    <div className="flex-row">
      <div className="form-group">
        <label>Rental Start:</label>
        <input
          name="rentalPeriodStart"
          value={form.rentalPeriodStart}
          onChange={handleChange}
          className="form-input"
          placeholder="YYYY-MM-DD"
        />
      </div>

      <div className="form-group">
        <label>Rental End:</label>
        <input
          name="rentalPeriodEnd"
          value={form.rentalPeriodEnd}
          onChange={handleChange}
          className="form-input"
          placeholder="YYYY-MM-DD"
        />
      </div>
    </div>

    <div className="form-group">
      <label>With Driver?</label>
      <select
        name="withDriver"
        value={form.withDriver}
        onChange={handleChange}
        className="form-input"
      >
        <option value="without">Without</option>
        <option value="with">With</option>
      </select>
    </div>

    <div className="form-group">
      <label>Payment Amount (words):</label>
      <input
        name="paymentAmountWords"
        value={form.paymentAmountWords}
        onChange={handleChange}
        className="form-input"
      />
    </div>

    <div className="form-group">
      <label>Payment Amount (Rs.):</label>
      <input
        name="paymentAmountFigure"
        value={form.paymentAmountFigure}
        onChange={handleChange}
        className="form-input"
      />
    </div>

    <div className="form-group">
      <label>Max Km per period:</label>
      <input
        name="maxKm"
        value={form.maxKm}
        onChange={handleChange}
        className="form-input"
      />
    </div>

    <div className="form-group">
      <label>Extra Km Rate (words):</label>
      <input
        name="extraKmRateWords"
        value={form.extraKmRateWords}
        onChange={handleChange}
        className="form-input"
      />
    </div>

    <div className="form-group">
      <label>Extra Km Rate (Rs.):</label>
      <input
        name="extraKmRateFigure"
        value={form.extraKmRateFigure}
        onChange={handleChange}
        className="form-input"
      />
    </div>

    <div className="form-group">
      <label>Security Deposit (Rs.):</label>
      <input
        name="securityDeposit"
        value={form.securityDeposit}
        onChange={handleChange}
        className="form-input"
      />
    </div>

    <div className="form-group">
      <label>Meter Reading:</label>
      <input
        name="meterReading"
        value={form.meterReading}
        onChange={handleChange}
        className="form-input"
      />
    </div>

    <div className="form-group">
      <label>Lessee Use Purpose:</label>
      <textarea
        name="lesseeUsePurpose"
        value={form.lesseeUsePurpose}
        onChange={handleChange}
        rows={2}
        className="form-textarea"
      />
    </div>

    <hr />

    {/* SURETY DETAILS */}
    <h3 className="section-title">Surety Details</h3>

    <div className="form-group">
      <label>Full Name:</label>
      <input
        name="suretyFullName"
        value={form.suretyFullName}
        onChange={handleChange}
        className="form-input"
      />
    </div>

    <div className="form-group">
      <label>N.I.C. No.:</label>
      <input
        name="suretyNIC"
        value={form.suretyNIC}
        onChange={handleChange}
        className="form-input"
      />
    </div>

    <div className="form-group">
      <label>Permanent Address:</label>
      <textarea
        name="suretyAddress"
        value={form.suretyAddress}
        onChange={handleChange}
        rows={2}
        className="form-textarea"
      />
    </div>

    <div className="form-group">
      <label>Telephone No.:</label>
      <input
        name="suretyTelephone"
        value={form.suretyTelephone}
        onChange={handleChange}
        className="form-input"
      />
    </div>

    <div className="form-group">
      <label>Relationship to the Lessee:</label>
      <input
        name="suretyRelationship"
        value={form.suretyRelationship}
        onChange={handleChange}
        className="form-input"
      />
    </div>

    <button type="submit" disabled={saving} className="submit-btn">
      {saving ? "Saving..." : "Save Agreement & Download PDF"}
    </button>
  </form>
</div>



)}







{/***************************************************** View All Agreements **********************************************************************/}



{selectedOption === "viewAgreements" && (
  <div className="view-agreements-container">
    <h1>View All Agreements</h1>

    {loadingAgreements ? (
      <p>Loading...</p>
    ) : agreements.length === 0 ? (
      <p>No agreements found.</p>
    ) : (
      <table className="agreements-table">
        <thead>
          <tr>
            {/* <th>Agreement ID</th> */}
            <th>Lessee Name</th>
            <th>Vehicle No</th>
            <th>Vehicle Type</th>
            <th>Date</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {agreements.map((a) => (
            <tr key={a.id}>
              {/* <td>{a.id}</td> */}
              <td>{a.lesseeFullName}</td>
              <td>{a.vehicleRegNo}</td>
              <td>{a.vehicleType}</td>
              <td>
                {a.agreementDay}/{a.agreementMonth}/{a.agreementYear}
              </td>

              <td>
<button
  type="button"
  className="btn-download"
  onClick={() => generateAgreementPDF(a)}
>
  Download
</button>


                <button
                  className="btn-delete"
                  onClick={() => deleteAgreement(a.id)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    )}
  </div>
)}















{/***************************************************** create invoice **********************************************************************/}




  {selectedOption === "createInvoice" && (
        <div className="invoice-container">
          <div
            className="invoice-wrapper"
            style={{
              maxWidth: '1200px',
              margin: '0 auto',
              height: '70vh',
              overflowY: 'auto',
              padding: '12px'
            }}
          >
            <div className="invoice-header">
              <h1>Create Invoice</h1>
              <p className="invoice-subtitle">Invoice Number: {invoiceNumber}</p>
            </div>

            {/* Company Information */}
            <div className="invoice-section">
              <h3 className="section-header">Company Information</h3>
              <div className="form-grid-2">
                <div className="form-group">
                  <label className="form-label"><UserOutlined /> Company Name:</label>
                  <input
                    type="text"
                    name="companyName"
                    value={formData.companyName}
                    onChange={handleInputChange}
                    className="form-input"
                    // editable as requested
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Invoice Number:</label>
                  <input
                    type="text"
                    value={invoiceNumber}
                    onChange={() => {}} // keep as display value; not readOnly per your "all editable" ask but invoice is generated from system
                    className="form-input"
                  />
                </div>
                <div className="form-group">
                  <label className="form-label"><UserOutlined /> Address:</label>
                  <input
                    type="text"
                    name="companyAddress"
                    value={formData.companyAddress}
                    onChange={handleInputChange}
                    className="form-input"
                  />
                </div>
                <div className="form-group">
                  <label className="form-label"><CalendarOutlined /> Invoice Date:</label>
                  <input
                    type="date"
                    name="invoiceDate"
                    value={formData.invoiceDate}
                    onChange={handleInputChange}
                    className="form-input"
                  />
                </div>
                <div className="form-group">
                  <label className="form-label"><PhoneOutlined /> Phone:</label>
                  <input
                    type="text"
                    name="companyPhone"
                    value={formData.companyPhone}
                    onChange={handleInputChange}
                    className="form-input"
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Email:</label>
                  <input
                    type="email"
                    name="companyEmail"
                    value={formData.companyEmail}
                    onChange={handleInputChange}
                    className="form-input"
                  />
                </div>
              </div>
            </div>

            {/* Customer Information */}
            <div className="invoice-section">
              <h3 className="section-header">Customer Information</h3>
              <div className="form-grid-2">
                <div className="form-group">
                  <label className="form-label"><UserOutlined /> Name: *</label>
                  <input
                    type="text"
                    name="customerName"
                    value={formData.customerName}
                    onChange={handleInputChange}
                    className="form-input"
                    required
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Address:</label>
                  <input
                    type="text"
                    name="customerAddress"
                    value={formData.customerAddress}
                    onChange={handleInputChange}
                    className="form-input"
                  />
                </div>
                <div className="form-group">
                  <label className="form-label"><PhoneOutlined /> Phone: *</label>
                  <input
                    type="text"
                    name="customerPhone"
                    value={formData.customerPhone}
                    onChange={handleInputChange}
                    className="form-input"
                    required
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Email:</label>
                  <input
                    type="email"
                    name="customerEmail"
                    value={formData.customerEmail}
                    onChange={handleInputChange}
                    className="form-input"
                  />
                </div>
              </div>
            </div>

            {/* Rental Summary */}
            <div className="invoice-section">
              <div className="rental-item-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h3 className="section-header">Rental Summary</h3>
                <button
                  type="button"
                  onClick={addRentalItem}
                  className="btn btn-secondary"
                  style={{ padding: '6px 10px', fontSize: '0.9rem' }}
                >
                  <PlusOutlined /> Add Vehicle
                </button>
              </div>

              <div className="rental-items-container">
                {formData.rentalItems.map((item, index) => (
                  <div key={index} className="rental-item" style={{ marginBottom: '10px', borderBottom: '1px solid #eee', paddingBottom: '8px' }}>
                    <div className="form-grid-4">
                      <div className="form-group">
                        <label className="form-label">Vehicle Description:</label>
                        <input
                          type="text"
                          value={item.vehicleDescription}
                          onChange={(e) => handleRentalItemChange(index, 'vehicleDescription', e.target.value)}
                          className="form-input"
                          style={{ fontSize: '0.9rem' }}
                        />
                      </div>




                      <div className="form-group">
                        <label className="form-label">Rental Period (select):</label>

                        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                          <input
                            type="text"
                            className="form-input"
                            // guard values using safeFormat
                            value={
                              `${safeFormat(item?.dateRange?.startDate)} → ${safeFormat(item?.dateRange?.endDate)}`
                            }
                            onFocus={() => setShowRangePickerIndex(index)}
                            readOnly
                            style={{ cursor: 'pointer' }}
                          />

                          <button
                            type="button"
                            onClick={() => setShowRangePickerIndex(showRangePickerIndex === index ? null : index)}
                            className="btn btn-light"
                            style={{ padding: '6px' }}
                          >
                            <CalendarOutlined />
                          </button>
                        </div>

                        {/* DateRange popup (renders only for the active index) */}
                        {showRangePickerIndex === index && (
                          <div style={{ position: 'relative', zIndex: 9999, marginTop: 8 }}>
                            <DateRange
                              // ranges expects an array with object { startDate, endDate, key }
                              ranges={[{
                                startDate: item?.dateRange?.startDate ? new Date(item.dateRange.startDate) : new Date(),
                                endDate: item?.dateRange?.endDate ? new Date(item.dateRange.endDate) : new Date(),
                                key: 'selection'
                              }]}
                              // important: pass locale so react-date-range doesn't crash
                              locale={enUS}
                              onChange={(rangeObj) => {
                                // rangeObj.selection has startDate and endDate
                                const start = rangeObj.selection.startDate;
                                const end = rangeObj.selection.endDate || rangeObj.selection.startDate;

                                // update your rental item — use your existing handler shape (example below)
                                handleDateRangeChange(index, {
                                  selection: { startDate: start, endDate: end, key: 'selection' }
                                });
                              }}
                              editableDateInputs={true}
                              moveRangeOnFirstSelection={false}
                              maxDate={new Date('2100-12-31')}
                            />

                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 6 }}>
                              <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={() => setShowRangePickerIndex(null)}
                              >
                                Done
                              </button>
                            </div>
                          </div>
                        )}
                      </div>



                      <div className="form-group">
                        <label className="form-label">Rate Per Day (Rs.):</label>
                        <input
                          type="number"
                          value={item.ratePerDay === 0 ? '' : item.ratePerDay}  // 👈 hide zero
                          onChange={(e) =>
                            handleRentalItemChange(
                              index,
                              "ratePerDay",
                              e.target.value === "" ? 0 : Number(e.target.value)
                            )
                          }
                          className="form-input"
                          style={{ width: "110px" }}
                        />
                      </div>



                      <div className="form-group">
                        <label className="form-label">Days (auto):</label>
                        <input
                          type="number"
                          value={item.numberOfDays === 0 ? '' : item.numberOfDays}  // 👈 hide zero
                          onChange={(e) => 
                            handleRentalItemChange(
                              index, 
                              'numberOfDays', 
                              e.target.value === '' ? 0 : Number(e.target.value)
                            )
                          }
                          className="form-input"
                          style={{ width: '90px' }}
                        />
                      </div>
                    </div>


                    <div className="form-grid-3" style={{ marginTop: '8px' }}>
                      <div className="form-group">
                        <label className="form-label">No. of KMs:</label>
                        <input
                          type="number"
                          value={item.numberOfKms  === 0 ? '' : item.numberOfKms}  // 👈 hide zero
                          onChange={(e) => handleRentalItemChange(index, 'numberOfKms', e.target.value === '' ? 0 : Number(e.target.value))}
                          className="form-input"
                          style={{ width: '110px' }}
                        />
                      </div>


                      <div className="form-group">
                        <label className="form-label">Extra Charges (Rs.):</label>
                        <input
                          type="number"
                          value={item.extraCharges === 0 ? '' : item.extraCharges}  // 👈 hide zero 
                          onChange={(e) => handleRentalItemChange(index, 'extraCharges', e.target.value === '' ? 0 : Number(e.target.value))}
                          className="form-input"
                          style={{ width: '110px' }}
                        />
                      </div>

                      <div className="form-group">
                        <label className="form-label">Subtotal (Rs.) — enter manually:</label>
                        <input
                          type="number"
                          value={item.subtotal === 0 ? '' : item.subtotal}  // 👈 hide zero
                          onChange={(e) => handleRentalItemChange(index, 'subtotal', e.target.value === '' ? 0 : Number(e.target.value))}
                          className="form-input"
                          style={{ width: '140px' }}
                        />
                      </div>
                    </div>

                    <div style={{ display: 'flex', gap: '8px', marginTop: '8px', alignItems: 'center' }}>
                      {formData.rentalItems.length > 1 && (
                        <button
                          type="button"
                          onClick={() => removeRentalItem(index)}
                          className="btn btn-danger btn-sm"
                        >
                          <MinusCircleOutlined /> Remove
                        </button>
                      )}

                      <div style={{ marginLeft: 'auto' }}>
                        <small>Suggested calc: <i>{`Rs. ${(Number(item.ratePerDay || 0) * Number(item.numberOfDays || 1) + Number(item.extraCharges || 0)).toLocaleString('en-US', { maximumFractionDigits: 2 })}`}</i></small>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="total-amount" style={{ marginTop: '10px' }}>
                <h3>Total: {formatRs(formData.totalAmount)}</h3>
              </div>
            </div>

            {/* Payment Method */}
            <div className="invoice-section">
              <h3 className="section-header">Payment Method</h3>
              <div className="form-grid-2">
                <div className="form-group">
                  <label className="form-label">Payment Method:</label>
                  <select
                    name="paymentMethod"
                    value={formData.paymentMethod}
                    onChange={handleInputChange}
                    className="form-select"
                  >
                    <option value="card/debit card">Credit/Debit Card</option>
                    <option value="bank deposit">Bank Deposit</option>
                    <option value="cheque">Cheque</option>
                    <option value="cash">Cash</option>
                  </select>
                </div>

                {formData.paymentMethod === 'card' && (
                  <div className="payment-details">
                    <div className="form-grid-2">
                      <div className="form-group">
                        <label className="form-label">Card Number:</label>
                        <input
                          type="text"
                          name="cardNumber"
                          value={formData.cardNumber}
                          onChange={handleInputChange}
                          placeholder="Last 4 digits"
                          className="form-input"
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Card Type:</label>
                        <select
                          name="cardType"
                          value={formData.cardType}
                          onChange={handleInputChange}
                          className="form-select"
                        >
                          <option value="visa">Visa</option>
                          <option value="mastercard">MasterCard</option>
                          <option value="amex">American Express</option>
                        </select>
                      </div>
                      <div className="form-group">
                        <label className="form-label">Payment Date:</label>
                        <input
                          type="date"
                          name="paymentDate"
                          value={formData.paymentDate}
                          onChange={handleInputChange}
                          className="form-input"
                        />
                      </div>
                    </div>
                  </div>
                )}

                {formData.paymentMethod === 'cheque' && (
                  <div className="payment-details">
                    <div className="form-grid-2">
                      <div className="form-group">
                        <label className="form-label">Cheque Number:</label>
                        <input
                          type="text"
                          name="chequeNumber"
                          value={formData.chequeNumber}
                          onChange={handleInputChange}
                          className="form-input"
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Cheque Date:</label>
                        <input
                          type="date"
                          name="chequeDate"
                          value={formData.chequeDate}
                          onChange={handleInputChange}
                          className="form-input"
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Action Button */}
            <div className="action-buttons" style={{ marginTop: '10px' }}>
              <button
                onClick={saveAndDownloadInvoice}
                className="btn btn-success"
                disabled={isSaving || !formData.customerName || !formData.customerPhone || Number(formData.totalAmount) <= 0}
                style={{ padding: '8px 12px', fontSize: '0.95rem' }}
              >
                {isSaving ? (
                  <>Processing...</>
                ) : (
                  <>
                    <SaveOutlined /> Save & Download Invoice
                  </>
                )}
              </button>
            </div>

            <div className="required-fields-note" style={{ marginTop: '8px' }}>
              <p>* Required fields: Customer Name and Phone must be filled</p>
            </div>
          </div>
        </div>
      )}


{/***************************************************************************************************************************/}




{selectedOption === "viewInvoice" && (
  <div className="view-invoices-container">
      <h1>View All Invoices</h1>
      <div className="table-wrapper">
        <Table
          dataSource={invoices}
          columns={columns}
          rowKey="id"
          loading={loading}
          pagination={{ pageSize: 10 }}
          scroll={{ y: "75vh", x: 1200 }}
        />
      </div>
    </div>

)}



{/***************************************************************************************************************************/}


{selectedOption === "salesReport" && (
  <div className="sales-report-container">
    {/* Header Section */}
    <div className="sales-report-header">
      <h1>Sales Analytics Dashboard</h1>
      <p>Comprehensive sales performance insights and reports</p>
    </div>

    {/* Controls Section */}
    <div className="controls-section">
      <div className="date-filters">
        <div className="filter-group">
          <label>Report Type:</label>
          <select 
            value={reportType} 
            onChange={(e) => setReportType(e.target.value)}
            className="filter-select"
          >
            <option value="daily">Daily Report</option>
            <option value="monthly">Monthly Report</option>
            <option value="yearly">Yearly Report</option>
            <option value="custom">Custom Range</option>
          </select>
        </div>

        {reportType === 'daily' && (
          <div className="filter-group">
            <label>Select Date:</label>
            <input 
              type="date" 
              value={selectedDate}
              onChange={(e) => setSelectedDate(e.target.value)}
              className="filter-input"
            />
          </div>
        )}

        {reportType === 'monthly' && (
          <div className="filter-group">
            <label>Select Month:</label>
            <input 
              type="month" 
              value={selectedMonth}
              onChange={(e) => setSelectedMonth(e.target.value)}
              className="filter-input"
            />
          </div>
        )}

        {reportType === 'yearly' && (
          <div className="filter-group">
            <label>Select Year:</label>
            <select 
              value={selectedYear}
              onChange={(e) => setSelectedYear(e.target.value)}
              className="filter-select"
            >
              {Array.from({length: 5}, (_, i) => new Date().getFullYear() - i).map(year => (
                <option key={year} value={year}>{year}</option>
              ))}
            </select>
          </div>
        )}

        {reportType === 'custom' && (
          <div className="filter-group double">
            <label>Date Range:</label>
            <div className="date-range">
              <input 
                type="date" 
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                className="filter-input"
              />
              <span>to</span>
              <input 
                type="date" 
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                className="filter-input"
              />
            </div>
          </div>
        )}
      </div>

      <div className="action-buttons">
        <button 
          className="btn-primary"
          onClick={generateReport}
        >
          📊 Generate Report
        </button>
        <button 
          className="btn-success"
          onClick={exportToExcel}
          disabled={!salesData.length}
        >
          📈 Export to Excel
        </button>
        <button 
          className="btn-secondary"
          onClick={refreshData}
        >
          🔄 Refresh
        </button>
      </div>
    </div>

    {/* KPI Cards */}
    {salesData.length > 0 && (
      <div className="kpi-cards">
        <div className="kpi-card revenue">
          <div className="kpi-icon">💰</div>
          <div className="kpi-content">
            <h3>Total Revenue</h3>
            <div className="kpi-value">
              Rs. {totalRevenue.toLocaleString()}
            </div>

          </div>
        </div>

        <div className="kpi-card invoices">
          <div className="kpi-icon">📄</div>
          <div className="kpi-content">
            <h3>Total Invoices</h3>
            <div className="kpi-value">{totalInvoices}</div>

          </div>
        </div>



        <div className="kpi-card vehicles">
          <div className="kpi-icon">🚗</div>
          <div className="kpi-content">
            <h3>Vehicles Rented</h3>
            <div className="kpi-value">{totalVehicles}</div>

          </div>
        </div>
      </div>
    )}

    {/* Charts Section */}
    {salesData.length > 0 && (
      <div className="charts-section">
        <div className="chart-container">
          <div className="chart-header">
            <h3>Revenue Trend</h3>
            <div className="chart-actions">

            </div>
          </div>
          <div className="chart-wrapper">
            {renderRevenueChart()}
          </div>
        </div>

        <div className="chart-container">
          <div className="chart-header">
            <h3>Payment Methods</h3>
          </div>
          <div className="chart-wrapper">
            {renderPaymentMethodChart()}
          </div>
        </div>


      </div>
    )}


  </div>
)}



{/***************************************************************************************************************************/}

      </div>
    </div>
  );
};

export default Body;
